import { render, staticRenderFns } from "./CompanyTagsTable.vue?vue&type=template&id=4ef195b2"
import script from "./CompanyTagsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyTagsTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports